module.exports = __webpack_public_path__ + "media/images/emblems/Torny-coat_of_arms-b92d6e2d7e924504c336a34f5ad49204.svg";